import { gql } from '@apollo/client'

export const createOneCredit = gql`
    mutation CreateOneCredit($date: String!, $userId: String!, $amount: Float!) {
        createOneCredit(date: $date, userId: $userId, amount: $amount) {
            amount
            id
        }
    }
`

export const updateUser = gql`
    mutation UpdateUser($userId: String!, $email: String, $role: Role, $isPremium: Boolean) {
        updateUser(userId: $userId, email: $email, role: $role, isPremium: $isPremium) {
            id
        }
    }
`

export const Login = gql`
    mutation Login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            user {
                id
            }
            token
        }
    }
`
export const createExplore = gql`
mutation CreateExplore($exRegion: [String!], $region: [String!], $webmUrl: String, $gif: String, $url: String, $thumbnailUrl: String, $aspectRatio: AspectRatioEnum, $style: ArtStyle, $motionScore: MotionScoreEnum, $categoryId: String, $lowResolutionUrl: String, $prompt: String) {
  createExplore(exRegion: $exRegion, region: $region, webmUrl: $webmUrl, gif: $gif, url: $url, thumbnailUrl: $thumbnailUrl, aspectRatio: $aspectRatio, style: $style, motionScore: $motionScore, categoryId: $categoryId, lowResolutionUrl: $lowResolutionUrl, prompt: $prompt) {
    id
    url
    lowResolutionUrl
    prompt
    thumbnailUrl
    motionScore
    style
    createdAt
    updatedAt
    aspectRatio
    location
    region
    exRegion
    gif
    webmUrl
    categoryId
  }
}
`
export const updateExplore = gql`
mutation UpdateExplore($exRegion: [String!], $region: [String!], $webmUrl: String, $gif: String, $url: String, $thumbnailUrl: String, $aspectRatio: AspectRatioEnum, $style: ArtStyle, $motionScore: MotionScoreEnum, $lowResolutionUrl: String, $prompt: String, $categoryId: String, $exploreId: String, $isHidden: Boolean) {
  updateExplore(exRegion: $exRegion, region: $region, webmUrl: $webmUrl, gif: $gif, url: $url, thumbnailUrl: $thumbnailUrl, aspectRatio: $aspectRatio, style: $style, motionScore: $motionScore, lowResolutionUrl: $lowResolutionUrl, prompt: $prompt, categoryId: $categoryId, exploreId: $exploreId, isHidden: $isHidden) {
    id
    url
    lowResolutionUrl
    prompt
    thumbnailUrl
    motionScore
    style
    isHidden
    createdAt
    updatedAt
    aspectRatio
    location
    region
    exRegion
    gif
    webmUrl
    categoryId
  }
}
`
export const deleteExplore = gql`
    mutation DeleteExplore($exploreId: String!) {
        deleteExplore(exploreId: $exploreId)
    }
`
export const createCategory = gql`
mutation CreateCategory($rowNumber: Int, $name: String, $description: String, $skipTranslation: Boolean, $type: ContentTypeEnum) {
  createCategory(rowNumber: $rowNumber, name: $name, description: $description, skipTranslation: $skipTranslation, type: $type) {
    id
    name
    description
    rowNumber
    updatedAt
    createdAt
    skipTranslation
    type
  }
}
`

export const updateCategory = gql`
mutation UpdateCategory($categoryId: String!, $name: String, $description: String, $rowNumber: Int, $skipTranslation: Boolean, $isHidden: Boolean, $type: ContentTypeEnum) {
  updateCategory(categoryId: $categoryId, name: $name, description: $description, rowNumber: $rowNumber, skipTranslation: $skipTranslation, isHidden: $isHidden, type: $type) {
    id
    name
    description
    rowNumber
    createdAt
    updatedAt
    isHidden
    skipTranslation
    type
  }
}
`

export const deleteCategory = gql`
    mutation DeleteCategory($categoryId: String!) {
        deleteCategory(categoryId: $categoryId)
    }
`
export const reorderCategories = gql`
    mutation ReorderCategories($ids: [String!]!) {
        reorderCategories(ids: $ids)
    }
`
export const deleteVideo = gql`
    mutation DeleteVideoAdmin($videoId: String!) {
        deleteVideoAdmin(videoId: $videoId)
    }
`

export const updateSystem = gql`
    mutation UpdateSystem($systemType: SystemTypeEnum!, $provider: SystemProviderEnum!, $updateSystemId: String!) {
        updateSystem(systemType: $systemType, provider: $provider, id: $updateSystemId) {
            id
            provider
            type
            createdAt
            updatedAt
        }
    }
`
export const updateFeedStatus = gql`
    mutation UpdateFeedStatus($status: FeedStatus!, $feedId: String!) {
        updateFeedStatus(status: $status, feedId: $feedId) {
            id
        }
    }
`
export const sendFcm = gql`
    mutation SendFcm($message: String!, $title: String!, $fcmId: String!) {
        sendFcm(message: $message, title: $title, fcmId: $fcmId)
    }
`

export const userTransfer = gql`
    mutation UserTransfer($destinationId: String!, $sourceId: String!) {
        userTransfer(destinationId: $destinationId, sourceId: $sourceId)
    }

`

export const updateCredit = gql`
    mutation UpdateCredit($creditId: String!, $expiryDate: DateTime, $amount: Float) {
        updateCredit(creditId: $creditId, expiryDate: $expiryDate, amount: $amount) {
            id
        }
    }

`
export const updateVideoStatus = gql`
    mutation UpdateVideoStatus($status: StatusEnum!, $videoId: String!) {
        updateVideoStatus(status: $status, videoId: $videoId) {
            id
        }
    }
`



export const getSignedUrl = gql`
    mutation GetSignedUrl($fileName: String!) {
        getSignedUrl(fileName: $fileName) {
            id
            url
            contentType
        }
    }
`
export const getObjectUrl = gql`
    mutation GetObjectUrl($eTag: String!, $key: String!) {
        getObjectUrl(eTag: $eTag, key: $key)
    }
`



export const deleteUserData = gql`
    mutation DeleteUserData($userId: String!) {
    deleteUserData(userId: $userId) {
      success
      message
      deletedItems
    }
  }
`

export const updateMultipleFeedStatus = gql`
    mutation UpdateMultipleFeedStatus($status: FeedStatus!, $feedIds: [String!]!) {
        updateMultipleFeedStatus(status: $status, feedIds: $feedIds) {
            id
            status
        }
    }
`

export const createCreditProduct = gql`
  mutation CreateCreditProduct($input: CreateCreditProductInput!) {
    createCreditProduct(input: $input) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
    }
  }
`

export const updateCreditProduct = gql`
  mutation UpdateCreditProduct($input: UpdateCreditProductInput!, $updateCreditProductId: String!) {
    updateCreditProduct(input: $input, id: $updateCreditProductId) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
    }
  }
`

export const deleteCreditProduct = gql`
  mutation DeleteCreditProduct($deleteCreditProductId: String!) {
    deleteCreditProduct(id: $deleteCreditProductId)
  }
`

export const upsertProductOffering = gql`
  mutation UpsertProductOffering($productId: String!, $presentedOfferingId: String!, $amount: Int!) {
    upsertProductOffering(productId: $productId, presentedOfferingId: $presentedOfferingId, amount: $amount) {
      id
      presentedOfferingId
      amount
      createdAt
      updatedAt
    }
  }
`

export const deleteProductOffering = gql`
  mutation DeleteProductOffering($id: String!) {
    deleteProductOffering(id: $id) {
      id
    }
  }
`

export const createTool = gql`
mutation CreateTool($input: CreateStudioInput!) {
  createTool(input: $input) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    lowResolutionUrl
    rowNumber
    templateId
    description
    prompt
    isFeatured
    isHidden
    duration
    categoryId
    cost
    actualCost
    provider
    createdAt
    updatedAt
    videoCount
    badgeText
    badgeIcon
    badgeTextColor
    badgeBackgroundColor
    skipTranslation
    type
    keywords
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const updateTool = gql`
mutation UpdateTool($input: UpdateStudioInput!, $updateToolId: String!) {
  updateTool(input: $input, id: $updateToolId) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    lowResolutionUrl
    rowNumber
    templateId
    description
    prompt
    isFeatured
    isHidden
    duration
    categoryId
    cost
    provider
    createdAt
    updatedAt
    videoCount
    badgeText
    badgeIcon
    badgeTextColor
    badgeBackgroundColor
    skipTranslation
    actualCost
    type
    keywords
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const deleteTool = gql`
mutation DeleteTool($deleteToolId: String!) {
    deleteTool(id: $deleteToolId) {
      id
      name
      imageType
      bannerUrl
      videoUrl
      rowNumber
      templateId
      description
      prompt
      isFeatured
      duration
      categoryId
      cost
      provider
      createdAt
      updatedAt
      videoCount
      webmUrl
      webpUrl
      aspectRatios {
        id
        width
        height
        name
        aspectRatioX
        aspectRatioY
        createdAt
        updatedAt
        toolId
      }
    }
  }
`

export const updateCreditConfig = gql`
  mutation UpdateCreditConfig($creditJson: JSON!) {
    updateCreditConfig(creditJson: $creditJson)
  }
`

export const updateImageCreditConfig = gql`
  mutation UpdateImageCreditConfig($creditJson: JSON!) {
    updateImageCreditConfig(creditJson: $creditJson)
  }
`

export const updateCreditConfigUnified = gql`
  mutation UpdateCreditConfigUnified($creditJson: JSON!) {
    updateCreditConfigUnified(creditJson: $creditJson)
  }
`

export const updateUnifiedMinVersion = gql`
  mutation UpdateUnifiedMinVersion($version: String!) {
    updateUnifiedMinVersion(version: $version)
  }
`

export const updateCreditConfigUnifiedV2 = gql`
  mutation UpdateCreditConfigUnifiedV2($creditJson: JSON!) {
    updateCreditConfigUnifiedV2(creditJson: $creditJson)
  }
`

export const updateUnifiedV2MinVersion = gql`
  mutation UpdateUnifiedV2MinVersion($version: String!) {
    updateUnifiedV2MinVersion(version: $version)
  }
`

export const updateModerationStatusMinVersion = gql`
  mutation UpdateModerationStatusMinVersion($version: String!) {
    updateModerationStatusMinVersion(version: $version)
  }
`

export const updateCatalogueStandards = gql`
  mutation UpdateCatalogueStandards($standardsJson: JSON!) {
    updateCatalogueStandards(standardsJson: $standardsJson)
  }
`

export const updateImageCreditConfigUnified = gql`
  mutation UpdateImageCreditConfigUnified($creditJson: JSON!) {
    updateImageCreditConfigUnified(creditJson: $creditJson)
  }
`

export const updateCreditConfigImageUnifiedV2 = gql`
  mutation UpdateCreditConfigImageUnifiedV2($creditJson: JSON!) {
    updateCreditConfigImageUnifiedV2(creditJson: $creditJson)
  }
`

export const updateImageStatus = gql`
  mutation UpdateImageStatus($status: StatusEnum!, $imageId: String!) {
    updateImageStatus(status: $status, imageId: $imageId) {
      id
    }
  }
`

export const deleteImageAdmin = gql`
  mutation DeleteImageAdmin($imageId: String!) {
    deleteImageAdmin(imageId: $imageId)
  }
`

export const addCreditToUserAdmin = gql`
  mutation AddCreditToUserAdmin($amount: Int!, $userId: String!, $expiryDate: DateTime!) {
    addCreditToUserAdmin(amount: $amount, userId: $userId, expiryDate: $expiryDate){
    id
    }
  }
`

export const createAppVersion = gql`
  mutation CreateAppVersion($version: String!, $reviewMode: Boolean) {
    createAppVersion(version: $version, reviewMode: $reviewMode) {
      id
      version
      reviewMode
      createdAt
      updatedAt
    }
  }
`

export const updateAppVersion = gql`
  mutation UpdateAppVersion($appVersionId: String!, $version: String, $reviewMode: Boolean) {
    updateAppVersion(appVersionId: $appVersionId, version: $version, reviewMode: $reviewMode) {
      id
      version
      reviewMode
      createdAt
      updatedAt
    }
  }
`

export const deleteAppVersion = gql`
  mutation DeleteAppVersion($appVersionId: String!) {
    deleteAppVersion(appVersionId: $appVersionId)
  }
`

export const CreatePricingConfig = gql`
  mutation CreatePricingConfig($proceedPerCredit: Float!, $costCap: Float!, $discount: Float!) {
    createPricingConfig(
      proceedPerCredit: $proceedPerCredit
      costCap: $costCap
      discount: $discount
    ) {
      id
    }
  }
`;

export const recalculateAllPricing = gql`
  mutation RecalculateAllPricing {
    recalculateAllPricing
  }
`;

export const createBanner = gql`
  mutation CreateBanner($input: CreateBannerInput!) {
    createBanner(input: $input) {
      id
      name
      rowNumber
      isActive
      audienceType
      targetingRules
      startDate
      endDate
      items {
        id
        actionType
        targetingRules
        sortOrder
      }
    }
  }
`;

export const updateBanner = gql`
  mutation UpdateBanner($id: String!, $input: UpdateBannerInput!) {
    updateBanner(id: $id, input: $input) {
      id
      name
      rowNumber
      isActive
      audienceType
      targetingRules
      startDate
      endDate
      items {
        id
        actionType
        targetingRules
        sortOrder
      }
    }
  }
`;

export const deleteBanner = gql`
  mutation DeleteBanner($id: String!) {
    deleteBanner(id: $id)
  }
`;

export const reorderBanners = gql`
  mutation ReorderBanners($ids: [String!]!) {
    reorderBanners(ids: $ids)
  }
`;
export const reorderTools = gql`
  mutation ReorderTools($ids: [String!]!) {
    reorderTools(ids: $ids)
  }
`;
export const createRemoteConfig = gql`
  mutation CreateRemoteConfig($name: String!, $defaultContent: JSON) {
    createRemoteConfig(name: $name, defaultContent: $defaultContent) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const updateRemoteConfigName = gql`
  mutation UpdateRemoteConfigName($id: String!, $name: String!) {
    updateRemoteConfigName(id: $id, name: $name) {
      id
      name
      updatedAt
    }
  }
`;

export const deleteRemoteConfig = gql`
  mutation DeleteRemoteConfig($id: String!) {
    deleteRemoteConfig(id: $id)
  }
`;

export const upsertRemoteConfigLocale = gql`
  mutation UpsertRemoteConfigLocale(
    $remoteConfigId: String!
    $locale: String!
    $content: JSON!
  ) {
    upsertRemoteConfigLocale(
      remoteConfigId: $remoteConfigId
      locale: $locale
      content: $content
    ) {
      id
      locale
      content
      updatedAt
    }
  }
`;

export const deleteRemoteConfigLocale = gql`
  mutation DeleteRemoteConfigLocale($remoteConfigId: String!, $locale: String!) {
    deleteRemoteConfigLocale(remoteConfigId: $remoteConfigId, locale: $locale)
  }
`;

export const translateRemoteConfigContent = gql`
  mutation TranslateRemoteConfigContent(
    $sourceContent: JSON!
    $targetLocales: [String!]!
    $sourceLocale: String
  ) {
    translateRemoteConfigContent(
      sourceContent: $sourceContent
      targetLocales: $targetLocales
      sourceLocale: $sourceLocale
    ) {
      locale
      content
      error
    }
  }
`;

export const setGlobalReviewMode = gql`
  mutation SetGlobalReviewMode($enabled: Boolean!) {
    setGlobalReviewMode(enabled: $enabled)
  }
`;

export const createTab = gql`
  mutation CreateTab($input: CreateTabInput!) {
    createTab(input: $input) {
      id
      name
      rowNumber
      isActive
      contentType
      additionMethod
      sortMode
      sortField
      sortDirection
      usageWindowDays
      typeFilter
      limit
      shuffleResults
      maxPerCategory
      items {
        id
        sortOrder
        categoryId
        toolId
      }
    }
  }
`;

export const updateTab = gql`
  mutation UpdateTab($id: String!, $input: UpdateTabInput!) {
    updateTab(id: $id, input: $input) {
      id
      name
      rowNumber
      isActive
      contentType
      additionMethod
      sortMode
      sortField
      sortDirection
      usageWindowDays
      typeFilter
      limit
      shuffleResults
      maxPerCategory
      items {
        id
        sortOrder
        categoryId
        toolId
      }
    }
  }
`;

export const deleteTab = gql`
  mutation DeleteTab($id: String!) {
    deleteTab(id: $id)
  }
`;

export const reorderTabs = gql`
  mutation ReorderTabs($ids: [String!]!) {
    reorderTabs(ids: $ids)
  }
`;

export const reorderTabItems = gql`
  mutation ReorderTabItems($tabId: String!, $ids: [String!]!) {
    reorderTabItems(tabId: $tabId, ids: $ids)
  }
`;

export const setTabCustomOrder = gql`
  mutation SetTabCustomOrder($tabId: String!, $ids: [String!]!) {
    setTabCustomOrder(tabId: $tabId, ids: $ids)
  }
`;

export const shuffleTabOrder = gql`
  mutation ShuffleTabOrder($tabId: String!) {
    shuffleTabOrder(tabId: $tabId) {
      id
      sortMode
      shuffleResults
    }
  }
`;

export const addTabItem = gql`
  mutation AddTabItem($tabId: String!, $categoryId: String, $toolId: String) {
    addTabItem(tabId: $tabId, categoryId: $categoryId, toolId: $toolId) {
      id
      sortOrder
      categoryId
      toolId
    }
  }
`;

export const removeTabItem = gql`
  mutation RemoveTabItem($id: String!) {
    removeTabItem(id: $id)
  }
`;

export const createSearchSuggestion = gql`
  mutation CreateSearchSuggestion($input: CreateSearchSuggestionInput!) {
    createSearchSuggestion(input: $input) {
      id
      term
      rowNumber
      isActive
    }
  }
`;

export const updateSearchSuggestion = gql`
  mutation UpdateSearchSuggestion($id: String!, $input: UpdateSearchSuggestionInput!) {
    updateSearchSuggestion(id: $id, input: $input) {
      id
      term
      rowNumber
      isActive
    }
  }
`;

export const deleteSearchSuggestion = gql`
  mutation DeleteSearchSuggestion($id: String!) {
    deleteSearchSuggestion(id: $id)
  }
`;

export const reorderSearchSuggestions = gql`
  mutation ReorderSearchSuggestions($orderedIds: [String!]!) {
    reorderSearchSuggestions(orderedIds: $orderedIds) {
      id
      term
      rowNumber
      isActive
    }
  }
`;
